module.exports = __webpack_public_path__ + "files/3ef2427e06b770cf8a69e721e87426a2.png";